import { Grid, Container, Stepper, Step, StepLabel, Button, Card, CardContent } from '@mui/material'
import { ArrowLeft } from 'react-feather'

import { GeneralInfoStep } from './GeneralInfoStep'
import { ManagementLog } from './ManagementLog'
import { DefaultFinishStep } from './DefaultFinishStep'

const steps = ['Información General', 'Bitácora']

export const FormGeneralManagements = ({ useFetchInit, readOnlyMode }) => {

    const {
        globalStates,
        Actions
    } = useFetchInit

    const { formOpeningMode, stepApplilication } = globalStates

    const {handleClickReturnStep, handleClickHideForm} = Actions

    const getStepContent = (stepApplilication) => {
        switch (stepApplilication) {
            case 0:
                return <GeneralInfoStep
                    useFetchInit = {useFetchInit}
                    readOnlyMode = {readOnlyMode}
                />
            case 1:
                return <ManagementLog
                    useFetchInit = {useFetchInit}
                    readOnlyMode = {readOnlyMode}
                />;
            default:
                throw new Error('Unknown step');
        }
    }

    return (
        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Card style={{zIndex:'1'}}>
                    <CardContent>
                        <Button
                            startIcon={<ArrowLeft/>}
                            variant='text'
                            color='error'
                            size='large'
                            sx={{ marginTop: 2, marginBottom : 2 }}
                            onClick={handleClickHideForm}
                        >
                            Volver a la pantalla anterior
                        </Button>
                        <div className="border-bottom border-dark"></div>

                        <Container component="main" maxWidth="md" sx={{ mb: 4 }}>
                            <Stepper activeStep={stepApplilication} sx={{ pt: 3, pb: 5 }}>
                                {steps.map((label) => (
                                    <Step key={label}>
                                        <StepLabel>{label}</StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Container>

                        <p className='text-danger'>* campos obligatorios</p>
                        {stepApplilication === steps.length ? (
                            <DefaultFinishStep
                                handleClickReturnStep={handleClickReturnStep}
                                handleClickCloseForm={handleClickHideForm}
                            />

                        ) : (
                            <>
                                {getStepContent(stepApplilication)}
                            </>
                        )}
                    </CardContent>
                </Card>
            </Grid> 
        </Grid>
    )
}
